import React from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { Button, Stack } from '@mui/material';
import {
    explorerLivestreamChannelPath,
    explorerPodcastPath,
    explorerSocialChannelPath,
} from './utils';
import { useExplorerClipsIa } from './useExplorerClipsIa';

type Format = 'ondemand' | 'livestreams' | 'clips';

type ExplorerChannelFormatLinksProps = {
    current: Format;
    onDemandId?: string | null;
    livestreamId?: string | null;
    clipsId?: string | null;
};

export function ExplorerChannelFormatLinks({
    current,
    onDemandId,
    livestreamId,
    clipsId,
}: ExplorerChannelFormatLinksProps) {
    const { t } = useTranslation('explorer');
    const navigate = useNavigate();
    const clipsIa = useExplorerClipsIa();

    if (!clipsIa) return null;

    const links: Array<{ to: string; label: string }> = [];
    if (current !== 'ondemand' && onDemandId) {
        links.push({
            to: explorerPodcastPath(onDemandId, { clipsIa: true }),
            label: t('seeOnDemand'),
        });
    }
    if (current !== 'livestreams' && livestreamId) {
        links.push({
            to: explorerLivestreamChannelPath(livestreamId, true),
            label: t('seeLivestreams'),
        });
    }
    if (current !== 'clips' && clipsId) {
        links.push({
            to: explorerSocialChannelPath(clipsId, true),
            label: t('seeClips'),
        });
    }
    if (links.length === 0) return null;

    return (
        <Stack direction="row" spacing={1} flexWrap="wrap" useFlexGap sx={{ mt: 0.75 }}>
            {links.map((link) => (
                <Button
                    key={link.to}
                    size="small"
                    variant="text"
                    onClick={() => navigate(link.to)}
                >
                    {link.label}
                </Button>
            ))}
        </Stack>
    );
}
